<template>
  <div class="srchInput">
    <input 
      type="text" 
      placeholder="재료명을 입력하세요." 
      ref="inputSrch"
      @keyup="keyupHandler"
      :value="srchStr"
    >
    <button 
      class="addBtn" 
      :class="activeClass" 
      @click="clickHandler"
    >재료 추가하기</button>
  </div>
</template>

<script>
import { commNewMapActions } from "@processEditor/CommNew";
import TagAddPopComm from "@TagAddPop/TagAddPopComm"; 

export default {
  mixins : [ TagAddPopComm ] , 
  data () {
    return {
      delay : 0 , // 300 
      timeout : null , 
      srchStr : '' , 
      activeClass : null , 
    }
  } , 
  watch : {
    tagOptionPopAddListViewBln : {
      deep : true , 
      handler ( viewBln ) {
        if ( viewBln ) {
          setTimeout(_=>{
            this.$refs.inputSrch.focus() ; 
          } , 250 ) ; 
        } else {
          this.srchStr = '' ; 
        }
      } , 
    } , 
    crntList : {
      handler ( list ) {
        // console.log( "list", list )
        // editor에서 장비를 신규 추가 관련 주석. >> 필요시 교체
        // if(this.crntTag?.type != "EQUIPMENT") {
        //   this.activeClass = list.filter(o => o.name.trim() === this.srchStr.trim()).length == 0 ? 'active' : null;
        // }else{
        //   this.activeClass = null;
        // }
        this.activeClass = list.filter(o => o.name.trim() === this.srchStr.trim()).length == 0 ? 'active' : null;
      } , 
    } , 
  } , 
  mounted () {} , 
  methods : {
    ...commNewMapActions([
      'searchTag' , 
      'addTag' , 
    ]) ,
    keyupHandler ( e ) {
      let { 
        srchStr , 
        crntTag : { type } , 
        srchHandler , 
      } = this ; 
      this.srchStr = e.target.value
      this.srchHandler() ; 
    } , // end of keyupHandler

    srchHandler () {
      let { 
        srchStr , 
        crntTag : { type } , 
      } = this ; 

      this.timeout = setTimeout( async _=> {
        const data = await this.$wApi.tag.gets({ name : srchStr || undefined , type }) ; 
        const tags = data[ type.toLowerCase() ] ; 
        this.setCrntList({ list : tags }) ; 
      } , this.delay ) ; 
    } , 

    async clickHandler () {
      let { 
        activeClass , 
        srchStr , 
        crntTag : { type } , 
        srchHandler , 
      } = this ; 
      
      if ( activeClass == null ) return ; 

      // 일단 문자열이 포함된 태그 목록이 있는지 검색을 한다. 
      const srchData = await this.searchTag({ name : srchStr , type }) ; 
      // 신규로 생성하고 싶은 태그의 문자열을 기존 태그목록과 비교하여 같은 태그가 존재하는지 확인한다.
      const srchEqualData = srchData[ type.toLowerCase() ].filter(( srch ) => srch.name == srchStr ) ; 
      
      let data = null ; 
      if ( srchEqualData.length == 1 ) {
        // 기존 진행 
        // 같은 태그가 이미 존재한다면 존재하는 태그도 생성 태그를 대체한다. 
        data = {
          name : srchEqualData[0].name , 
          tagId : srchEqualData[0].id , 
          tagType : srchEqualData[0].tagType , 
        }
      } else {
        // 신규 진행 
        // 같은 태그가 존재하지 않는다면 신규 태그를 생성한다. 

        console.log( 
          'srchStr : ' , srchStr , '\n' , 
          'type : ' , type , '\n' , 
        ) ; 
        
        data = await this.addTag({
          name : srchStr , 
          tagType : type , 
        }) ; 
      }

      srchHandler() ; 
    } , // end of clickHandler
  }
}
</script>

<style lang="scss" scoped>
  .srchInput {
    position: relative; 
    padding: 0 10px; 
    width: 250px; 
    border: 1px solid $gray-9; 
    display: flex; 
    align-items: center; 
    
    input {
      height: 40px; 
      width: 100%; 
      border: 0; 

      &::placeholder {
        color: $gray-d; 
      }
    }
    .addBtn {
      width: 24px; height: 24px; 
      flex-shrink: 0; 
      font-size: 0; 
      background-color: $gray-f5;
      border-radius: 4px; 
      position: relative; 
      cursor: default; 

      &::before , &::after {
        content: ''; 
        display: flex; 
        background-color: $gray-d; 
        position: absolute; 
        width: 14px; height: 2px; 
        left: calc( 50% - 7px ); 
        top: calc( 50% - 1px ); 
        z-index: 2;
      } 
      &::after {
        transform: rotate( 90deg ); 
      }
      &.active {
        background-color: $gray-3; 
        cursor: pointer; 
      }
    }
  }
</style>